import { Controller } from "@hotwired/stimulus";
class default_1 extends Controller {
    connect() {
        /*
        const rowForms = Array.from(
          this.containerTarget.querySelectorAll<HTMLElement>(".row-form")
        );
    
        rowForms.forEach((form, index) => {
          const buttons = form.querySelectorAll<HTMLButtonElement>(
            ".scale-container > button"
          );
    
          buttons.forEach((button) => {
            button.addEventListener("click", () => {
              this.scrollToNext(rowForms, index);
            });
          });
        });
        */
        document.addEventListener("turbo:frame-load", () => {
            document.querySelectorAll(".scale-item").forEach((btn) => {
                btn.offsetHeight; // forces WebKit repaint
            });
        });
    }
    getHeaderOffset() {
        const extraMargin = 15;
        const stickyHeader = document.querySelector("#navbar-steps");
        return stickyHeader?.offsetHeight + extraMargin || extraMargin;
    }
    scrollToNext(forms, index) {
        const headerOffset = this.getHeaderOffset();
        if (index + 1 < forms.length) {
            // Get the next element from the array rowForms.
            const nextRowForm = forms[index + 1];
            // Calculate the top value to scroll to.
            const top = nextRowForm.getBoundingClientRect().top + window.scrollY - headerOffset;
            setTimeout(() => {
                window.scrollTo({
                    top,
                    behavior: "smooth",
                });
            }, 500);
        }
    }
    /**
     * Scroll to the first incomplete form of the container.
     * @param {any} _:Event
     * @returns {void}
     */
    goToUncompleted(_) {
        const rowForms = Array.from(this.containerTarget.querySelectorAll(".row-form"));
        const headerOffset = this.getHeaderOffset();
        for (const form of rowForms) {
            const buttons = Array.from(form.querySelectorAll(".form-verif-btn"));
            // Check if none of the buttons have the "row-checked" class
            const allIncomplete = buttons.every((btn) => {
                return !btn.classList.contains("row-checked");
            });
            if (buttons.length > 0 && allIncomplete) {
                const top = form.getBoundingClientRect().top + window.scrollY - headerOffset;
                window.scrollTo({
                    top,
                    behavior: "smooth",
                });
                break;
            }
        }
    }
    unlockRow(event) {
        event.preventDefault();
        // Remove the disabled attribute from the fieldset
        const target = event.target;
        const rowForm = target.closest(".row-form");
        const fieldset = rowForm?.querySelector("fieldset.scale-container");
        if (fieldset) {
            fieldset.disabled = false;
        }
        // Change the lock icon
        const icon = rowForm?.querySelector("i");
        if (icon) {
            icon.classList.remove("bi-shield-lock-fill", "text-warning");
            icon.classList.add("bi-shield-check", "text-success");
        }
    }
}
default_1.targets = ["container"];
export default default_1;
